import { React, useState } from "react";

import {
  SimpleForm,
  TextInput,
  BooleanInput,
  useNotify,
  useRefresh,
  useDataProvider,
  Button,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import { Dialog, DialogTitle } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DialogToolbar from "./dialogs/DialogToolbar";
import { customComponentsTypes } from "../../customComponentsTypes";

const EditVersion = ({ record, resource, mode }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const [isOpen, setIsOpen] = useState(false);
  const [versionName, setVersionName] = useState(record.name);
  const [masterPageId, setMasterPageId] = useState(record.componentId);
  const [isDraft, setIsDraft] = useState(record.isDraft);

  const onSubmit = () => {
    return dataProvider
      .update(resource, {
        id: record.id,
        data: {
          name: versionName,
          isDraft: isDraft,
          customComponentId: masterPageId,
        },
        meta: { useFormData: false, suffix: "metadata" },
      })
      .then(() => {
        notify("Версията е редактирана успешно!", { type: "success" });
        refresh();
        setIsOpen(false);
      })
      .catch(error => {
        notify("Версията не е редактирана!", { type: "error" });
        refresh();
        setIsOpen(false);
      });
  };

  return (
    <>
      <Button
        label="Редактирай"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <EditIcon />
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={isOpen}
      >
        <DialogTitle>{`Редактирай версия с № ${record.id}, име:  ${record.name}`}</DialogTitle>
        <SimpleForm
          onSubmit={onSubmit}
          toolbar={
            <DialogToolbar
              onCancel={() => {
                setIsOpen(false);
              }}
            />
          }
        >
          <TextInput
            fullWidth
            source="name"
            label="Име на нова версия"
            onChange={e => setVersionName(e.target.value)}
          />
          {mode === "page" && (
            <ReferenceInput
              reference="custom-components-cms"
              source="componentId"
              filter={{ Type: customComponentsTypes.masterpage }}
              queryOptions={{ meta: { mixed_provider: true } }}
            >
              <AutocompleteInput
                label="Master page ID"
                filterToQuery={q => ({ Query: q })}
                fullWidth
                optionValue="id"
                optionText="name"
                onChange={val => setMasterPageId(val)}
              />
            </ReferenceInput>
          )}
          <BooleanInput
            source="isDraft"
            label="Чернова"
            onChange={e => {
              setIsDraft(e.target.checked);
            }}
          />
        </SimpleForm>
      </Dialog>
    </>
  );
};

export default EditVersion;
